const streams = {
  bindings: {
    isLocked: '<',
  },
  templateUrl: '/modules/pis-tool/streams/streams.html',
  controller: 'StreamsController',
};

angular
  .module('pis-tool.module')
  .component('streams', streams)
  .config(function($stateProvider) {
    $stateProvider.state('pis.workspaces.streams', {
      url: '/streams',
      views: {
        'pisview@pis': 'streams',
      },
      resolve: {},
    });
  });
